import { appendQueryParams } from "../../utilities/urlUtils";
import { AxiosMULEEX, AxiosQUANTUM, userId } from "../apiConfig";

export const authApiFactory = {
  $_validateDomain(val){
    let url = `/organizations/domain-check/${val}`;
    return AxiosMULEEX.get(url);
  },
  $_login(payload) {
    let url = `/users/login`;
    return AxiosMULEEX.post(url, payload);
  },
  $_quantumLogin(payload) {
    let url = `/auth/login`;
    return AxiosQUANTUM.post(url, payload);
  },
  $_logout() {
    let url = "/users/logout";
    return AxiosMULEEX.get(url);
  },
  $_signUpUser(payload) {
    let url = `/signup`;
    return AxiosMULEEX.post(url, payload);
  },
  $_verifySignupAuthenticationCode(payload) {
    let url = `/signup/verify/code`;
    return AxiosMULEEX.post(url, payload);
  },
  $_validateSignupAuthenticationToken(payload) {
    let url = `/signup/verify/code`;
    return AxiosMULEEX.post(url, payload);
  },
  $_resendVerificationCode(userId = "", email = "") {
    let url = `/security/activateTwoFA`;
    const payload = {
      userId, email
    }
    return AxiosMULEEX.patch(url, payload);
  },
  $_resendSignUpOtpCode(params) {
    const payload = {
      ...params
    }
    let url = `/signup/resendverification${appendQueryParams(payload)}`;
    return AxiosMULEEX.get(url);
  },
  $_loginWithToken(payload) {
    let url = `/users/login-with-token`;
    return AxiosMULEEX.post(url, payload);
  },
  $_submitNewUserPassword(payload) {
    let url = `/signup/password`;
    return AxiosMULEEX.post(url, payload);
  },
  $_getResetPasswordLink(payload) {
    let url = `/users/forget-password`;
    return AxiosMULEEX.post(url, payload);
  },
  $_checkResetPasswordTokenValidity(token, email, id) {
    let url = `/reset-password?token=${token}&email=${email}&id=${id}`;
    return AxiosMULEEX.get(url);
  },
  $_resetPasswordForForgotPassword(payload) {
    let url = "/users/reset-password";
    return AxiosMULEEX.post(url, payload);
  },
  $_resetPassword(payload) {
    let url = `/reset-password`;
    return AxiosMULEEX.post(url, payload);
  },
  $_saveUserUseCase(payload) {
    let url = "/signup/onboarding/update-type";
    return AxiosMULEEX.post(url, payload);
  },
  $_saveUserAccountType(payload) {
    let url = "/signup/account-type";
    return AxiosMULEEX.post(url, payload);
  },
  $_saveOrganizationInformation(payload) {
    let url = "/signup/orgs";
    return AxiosMULEEX.post(url, payload);
  },
  $_updateOrganizationInformation(payload) {
    let url = `security/update-contact-detail/${userId()}`;
    return AxiosMULEEX.patch(url, payload);
  },
  $_saveAccountOwnerInformation(payload) {
    let url = `security/update-contact-detail/${userId()}`;
    return AxiosMULEEX.patch(url, payload);
  },
  $_saveOnboardingAccountOwnerInformation(payload, uId) {
    let url = `security/update-contact-detail/${uId}`;
    return AxiosMULEEX.patch(url, payload);
  },
  $_findUserDetails() {
    let url = `/security/find-user-contact-details/${userId()}`;
    return AxiosMULEEX.get(url);
  },
  $_updatePassword(payload) {
    let url = "/security/security-information";
    return AxiosMULEEX.post(url, payload);
  },
  $_verifyUser(payload) {
    let url = "/security/activate";
    return AxiosMULEEX.patch(url, payload);
  },
  $_requestOtp(payload) {
    let url = "/security/activateTwoFA";
    return AxiosMULEEX.patch(url, payload);
  },
  $_verifyOtp(payload) {
    let url = "/security/validate";
    return AxiosMULEEX.post(url, payload);
  },
  $_verifyOtpForLogin(payload) {
    let url = "/security/uservalidate";
    return AxiosMULEEX.patch(url, payload);
  },
  $_getImage(payload) {
    return AxiosMULEEX.get(payload);
  },
  $_saveBusinessKycInformation(payload) {
    let url = `security/kyc-company/${userId()}`;    
    return AxiosMULEEX.patch(url, payload);
  },
   $_getBizzDocs() {
    let url = `/users/documents/summary/${userId()}`;
    return AxiosMULEEX.get(url);
  },
};
